export default {
      id: "video-event_drivers-eyes-closed-usage",
      viewBox: "0 0 24 15",
      url: __webpack_public_path__ + "img/icons.svg#video-event_drivers-eyes-closed",
      toString: function () {
        return this.url;
      }
    }